<template>
  <div>

    <h6 class="mb-3">Testes:</h6>

    <EllipsisLoader v-if="isLoading" />
    <div v-else>
      <h6 v-if="tests.length == 0" class="mb-0 font-weight-normal text-secondary">Nenhum teste cadastrado.</h6>

      <h6 v-if="tests.length > 0 && tests.filter((test) => test.status == 'pending').length == 0" class="mb-0 font-weight-normal text-secondary mb-3">
        Você concluiu todos os testes da oportunidade.
      </h6>

      <h6 v-if="tests.length > 0 && tests.filter((test) => test.status == 'pending').length == 1" class="mb-0 font-weight-normal text-secondary mb-3">
        Falta {{ tests.filter((test) => test.status == 'pending').length }} teste para finalizar sua inscrição.
      </h6>

      <h6 v-if="tests.length > 0 && tests.filter((test) => test.status == 'pending').length > 1" class="mb-0 font-weight-normal text-secondary mb-3">
        Faltam {{ tests.filter((test) => test.status == 'pending').length }} testes para finalizar sua inscrição.
      </h6>

      <div v-for="(test, i) in tests" v-if="test.hide_to_candidate == false">
        <router-link
          v-if=" test.source == 'ninenine_jobs' && test.status == 'pending'"
          to=""
          @click.native="goToTest(`${test.name}/${test.test_id}`)"
          class="d-flex align-items-center mb-3 text-secondary"
        >
          <file-document-outline-icon class="mr-1" style="font-size:30px;" />

          <div>
            <h6 class="mb-1 font-weight-normal">{{ test.name }}</h6>
            <p class="small mb-0">Pendente</p>
          </div>
        </router-link>

        <router-link
          v-if="test.source != 'ninenine_jobs' && test.status == 'pending'"
          to=""
          @click.native="alertPartner(test.url)"
          class="d-flex align-items-center mb-3 text-secondary"
        >
          <file-document-outline-icon class="mr-1" style="font-size:30px;" />
          <div>
            <h6 class="mb-1 font-weight-normal">{{ test.name }}</h6>
            <p class="small mb-0">Pendente</p>
          </div>
        </router-link>

        <div v-if="test.status == 'finished'" class="d-flex align-items-center mb-3 text-secondary">
          <file-check-outline-icon class="mr-1 text-green-ml" style="font-size:30px;" />
          <div>
            <h6 class="mb-1 font-weight-normal">{{ test.name }}</h6>
            <p class="small mb-0">Finalizado</p>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import FileDocumentOutlineIcon from 'vue-material-design-icons/FileDocumentOutline.vue';
import FileCheckOutlineIcon from '@/components/mlIcons/FileCheckOutline';
import EllipsisLoader from '../Loader/EllipsisLoader.vue';

export default {
  name: 'SubscriptionTests',

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    tests() {
      const currentOpportunitySubscription = this.$store.state.opportunities.subscriptions.find((subscription) => subscription.opportunityId == this.subscription.opportunityId);

      if (currentOpportunitySubscription) {
        let tests = currentOpportunitySubscription.onlineTests.records;
        tests = tests.filter((test) => test.hide_to_candidate == false);
        return tests;
      }

      return [];
    },
  },

  props: {
    subscription: {
      type: Object,
      default: '',
    },
  },

  components: {
    FileDocumentOutlineIcon,
    FileCheckOutlineIcon,
    EllipsisLoader,
  },

  methods: {
    goToTest(testId) {
      window.afterTestBackTo = this.$route.fullPath;
      this.$router.push(`vagas/${this.subscription.opportunityId}/inscricao/${testId}`);
    },

    alertPartner(link) {
      this.$swal({
        title: 'Atenção',
        text: 'Você será direcionado para o site parceiro para realizar o teste.',
        type: 'info',
        showCancelButton: true,
        cancelButtonText: 'Fechar',
        confirmButtonText: 'Vamos lá!',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          window.open(link, '_blank');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  /deep/ .lds-ellipsis div{
    background: theme-color('blue-ml');
  }
</style>
